export const SET_TEMPLATEDROPDOWNVALUE = `SET_TEMPLATEDROPDOWNVALUE`;
export const SET_SOURCEDROPDOWNVALUE = `SET_SOURCEDROPDOWNVALUE`;
export const SET_REASONCODEDROPDOWNVALUE = `SET_REASONCODEDROPDOWNVALUE`;
export const SET_NOOFRECIPIENTDROPDOWNVALUE = `SET_NOOFRECIPIENTDROPDOWNVALUE`;
export const SET_URGENCYDROPDOWNVALUE = `SET_URGENCYDROPDOWNVALUE`;
export const SET_REASONINBRIEF = `SET_REASONINBRIEF`;
export const SET_ISSENDAPPROVAL = `SET_ISSENDAPPROVAL`;
export const SET_DLFILENAME = `SET_DLFILENAME`;
export const SET_SELECTEDDLFILE = `SET_SELECTEDDLFILE`;
export const SET_ISADDTEMPLATE = `SET_ISADDTEMPLATE`;
export const SET_ISEDITTEMPLATE = `SET_ISEDITTEMPLATE`

export const setTemplateDropDownValue = (data) => ({
    type: SET_TEMPLATEDROPDOWNVALUE,
    value: data
});

export const setSourceDropDownValue = (data) => ({
    type: SET_SOURCEDROPDOWNVALUE,
    value: data
});

export const setReasonCodeDropDownValue = (data) => ({
    type: SET_REASONCODEDROPDOWNVALUE,
    value: data
});

export const setNoOfRecipientDropDownValue = (data) => ({
    type: SET_NOOFRECIPIENTDROPDOWNVALUE,
    value: data
});

export const setReasonInBrief = (data) => ({
    type: SET_REASONINBRIEF,
    value: data
});

export const setUrgencyDropDownValue = (data) => ({
    type: SET_URGENCYDROPDOWNVALUE,
    value: data
});

export const setIsSendApproval = (data) => ({
    type: SET_ISSENDAPPROVAL,
    value: data
});

export const setDlFileName = (data) => ({
    type: SET_DLFILENAME,
    value: data
});

export const setSelectedDlFile = (data) => ({
    type: SET_SELECTEDDLFILE,
    value: data
});

export const setIsAddTemplate = (data) => ({
    type: SET_ISADDTEMPLATE,
    value: data
});

export const setIsEditTemplate = (data) => ({
    type: SET_ISEDITTEMPLATE,
    value: data
});








